import React from 'react';
import { Grid, TreeNavigation, ButtonBar, Button, ButtonSize, Alert, Loader } from 'react-unity';
import {
	OnPremAbstractPORForm,
	AbstractPORFormState,
	AbstractPORFormProps,
	IOnPremObjReqStateForm,
} from './OnPremAbstractPORequestObjectForm';
import WorkflowDetailWrapper from '../common/wrappers/OnPremWorkflowDetailWrapper';
import { OnPremObjectTable } from './components/OnPremObjectsTable';
import TextInputField from '../../components/common/form-controls/TextInputField';
import UserLookup from '../common/form-controls/Lookups/UserLookup';
import TextAreaField from '../common/form-controls/TextareaField';
import AlertModal from '../common/modals/AlertModal';
import ConfirmModal from '../common/modals/ConfirmModal';
import { WorkflowState } from '../../models/enums/WorkflowState';
import OnPremPortOpeningRequestsCreate from './OnPremPORequestObjectsCreate';
import './OnPremPORequestObjectsDetail.css';
import { useParams } from 'react-router-dom';
import { ApproverInput } from '../PortOpeningRequests/components';
import ChangeStatusObjectRequestOnPrem from '../../models/viewModels/OnPremPORequestObjects/ChangeStatusObjectRequestOnPrem';
import UpdateOnPremObjectRequest from '../../models/viewModels/OnPremPORequestObjects/UpdateOnPremObjectRequest';
import OnPremPORequestObject from '../../models/entities/OnPremPORequestObject';
import PortOpeningObjectOnPrem from '../../models/entities/OnPremPortOpeningObject';
import CartaInput from '../common/form-controls/Lookups/CartaInput';
import { OnPremPORScopeInput } from '../OnPremPortOpeningRequests/components/OnPremPORScopeInput';
import { OnPremPortOpeningRequestsTypes } from '../../models/enums/POR/OnPremPortOpeningRequestsTypes';
import SelectField from '../common/form-controls/SelectField';
import { PortOpeningRequestsDirection } from '../../models/enums/POR/PortOpeningRequestsDirection';
import { Validation } from '../../utils/Validation';
import {ToggleField} from '../common/';
import { OnPremPORTypeInput } from '../OnPremPortOpeningRequests/components/OnPremPORTypeInput';
import ProgressBarBig from '../OnPremPortOpeningRequests/components/ProgressBarBig';
import { Icon } from '../common/components/Icon';

interface PortOpeningRequestsDetailWithParamsProps extends AbstractPORFormProps {}

interface StateForm extends IOnPremObjReqStateForm {}

interface ObjectRequestDetailsWithParamsState extends AbstractPORFormState<StateForm> {
	escalationType?: string | null;
	loading: boolean;
	portOpeningRequestOnPrem?: OnPremPORequestObject;
	editMode: boolean;
	matchPatch: string;
	implementedObjects: PortOpeningObjectOnPrem[];

	decisionModalVisible: {
		approve?: boolean;
		reject?: boolean;
		review?: boolean;
		cancel?: boolean;
		escalate?: boolean;
		complete?: boolean;
	};
	modalComment: string;
	selectedFromExisting: string[];
}

class ObjectRequestDetailsWithParams extends OnPremAbstractPORForm<
	PortOpeningRequestsDetailWithParamsProps,
	ObjectRequestDetailsWithParamsState
> {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			stateForm: {
				selectedType: '',
				contact: null,
				approverDOAG: null,
				trackerID: null,
				firewall: '',
				cartaId: [],
				justification: '',
				changeTicketId: null,
				onPremObjects: [],
				creationDate: new Date(),
				projectAccountUser: null,
				projectId: '',
			},
			editMode: false,
			submissionWarned: false,
			operationInProgress: false,
			endModal: {
				visible: false,
			},
			submissionAlert: {
				visible: false,
			},
			decisionModalVisible: {},
			modalComment: '',
			selectedFromExisting: [],
			matchPatch: null,
			escalationType: null,
			implementedObjects: [],
		};
		this.initFormModel();
	}

	initFormModel() {
		super.initFormModel();

		this.formModel.addField('type', {
			getValue: () => this.state.stateForm.selectedType,
			validation: {
				required: true,
			},
		});
		this.formModel.fields.trackerID.validation = new Validation({
			required: () =>
				this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternalCertConnection.name,
			rules: [
				{
					assert: () => /^[0-9]*$/.test(this.state.stateForm.trackerID?.toString() ?? ''),
					message: 'Only numbers are valid values',
				},
				{
					assert: () => this.state.stateForm.trackerID >= 10000,
					message: 'Tracker ID must be greater than 10000',
				},
			],
		});

		this.formModel.fields.cartaId.validation = new Validation({
			required: () => this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternetDMZ.name,
		});

		this.formModel.fields.appEndorserId.validation = new Validation({
			required: () => this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternetDMZ.name,
		});

		this.formModel.fields.approverId.validation = new Validation({
			required: this.requiresDOAGApproval(this.state.portOpeningRequestOnPrem?.type?.name) ? true : false
		});

		this.formModel.fields.ownerDelegate.validation = new Validation({
			required: () =>
				this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternalCertConnection.name,
		});
		this.formModel.addField('onPremPortOpeningRequestObjectId', {
			getValue: () => this.por()?.id,
		});
	}

	async componentWillMount() {
		const id = parseInt(this.props.params.porId);
		await this.loadRequest(id);
	}

	loadRequest = async (id) => {
		this.setState(
			{
				loading: true,
			},
			async () => {
				try {
					const objectRequest = await this.OnPremObjectRequestService.getById(id).then(
						(response) => new OnPremPORequestObject(response)
					);

					this.setState(
						{
							portOpeningRequestOnPrem: objectRequest,
							loading: false,
						},
						this.resetStateForm
					);

					this.setState({
						selectedFromExisting: (this.state.stateForm.onPremObjects || []).map((rule) => rule.name),
					});

					if (objectRequest.type?.name == OnPremPortOpeningRequestsTypes.InternalCertConnection.name) {
						objectRequest.isInState(WorkflowState.Review) && objectRequest.isEditable()
							? await this.handleApproverDelegateOptions(objectRequest.trackerID, true)
							: this.loadOptions(objectRequest);
					} else {
						objectRequest.isInState(WorkflowState.Review) && objectRequest.isEditable()
							? await this.handleAppEndorserOptions(objectRequest.cartaId?.[0]?.cartaAppId)
							: this.loadOptions(objectRequest);
					}

					this.setState({
						implementedObjects: await this.getImplementedRulesToShow(),
					});
				} catch (error) {
					const HTTP_FORBIDDEN_ERROR_CODE = 403;
					if (error.status === HTTP_FORBIDDEN_ERROR_CODE) {
						this.handleEndModal(
							'You are not allowed to see this request.',
							'error',
							5000,
							'/onPremPortOpeningRequests'
						);
					} else {
						console.log(error);
						this.handleEndModal(
							'The request could not be retrieved.',
							'error',
							10000,
							'/onPremPortOpeningRequests'
						);
					}
				}
			}
		);
	};

	resetStateForm = () => {
		this.setState((prevState) => ({
			stateForm: this.stateFormFromRequest(prevState.portOpeningRequestOnPrem),
		}));
	};

	por = () => this.state.portOpeningRequestOnPrem;

	loadOptions = (por: OnPremPORequestObject) => {
		const options = [];
		if (por.type) {
			switch (por.type) {
				case OnPremPortOpeningRequestsTypes.InternalCertConnection:
					if (por.approvingUser) {
						options.push({ value: por.approvingUser.id, text: por.approvingUser.displayName });
					}
					this.setState({ approverDelegateOptions: options });
					break;
				case OnPremPortOpeningRequestsTypes.InternetDMZ:
					if (por.appEndorser?.customFields) {
						options.push({
							value: por.appEndorser.customFields.contact_email,
							text:
								por.appEndorser.customFields.first_name + ' ' + por.appEndorser.customFields.last_name,
						});
					}
					this.setState({ appEndorserOptions: options });
					break;
			}
		}
	};

	stateFormFromRequest(por: OnPremPORequestObject): StateForm {
		if (this.por()?.isInState(WorkflowState.Review, WorkflowState.Draft)) {
			let obj = {
				...super.stateFormFromRequest(por),
				selectedType: por.type?.name || new OnPremPortOpeningRequestsTypes().fromName('InternetDMZ').name, //'',
			};
			return {
				...obj,
				onPremObjects: (obj.onPremObjects || []).map((rule) => {
					return { ...rule, azureName: undefined };
				}),
			};
		}
		return {
			...super.stateFormFromRequest(por),
			selectedType: por.type?.name || new OnPremPortOpeningRequestsTypes().fromName('InternetDMZ').name, //'',
		};
	}

	setSelectedFromExisting = (rulesName: string[]) => {
		this.setState({
			selectedFromExisting: rulesName,
		});
	};

	getImplementedRulesToShow = async (): Promise<PortOpeningObjectOnPrem[]> => [];

	handleSave = () => {
		const operation = async () => {
			const model = this.formModel.create(UpdateOnPremObjectRequest);
			const appEndorser = this.state.stateForm.appEndorser;

			model.appEndorserId = appEndorser?.id ?? null;
			model.appEndorserMail = appEndorser?.id
				? null
				: appEndorser?.customFields?.contact_email ?? null;
			await this.OnPremObjectRequestService.update(this.por()?.id, model);
			this.setState({
				editMode: false,
			});
		};

		this.handleOperationConfirmed({
			operation,
			inProgressMessage: 'Updating request...',
			successMessage: 'Your request was updated successfully.',
		});
	};

	actions = () =>
		!this.state.operationInProgress && (
			<TreeNavigation className="em-u-clickable">
				{this.por()?.isEditable() && (
					<>
						<TreeNavigation.Item
							label="Edit"
							className="em-c-btn em-c-btn--secondary em-c-btn--small"
							onClick={this.enableEdit}
						/>
						<br />
						<br />
					</>
				)}
				{(this.por()?.canHaveDOAGApproval() ||
					this.por()?.canHaveAppOwnerApproval() ||
					this.por()?.canHaveConnOwnerApproval() ||
					this.por()?.canHaveReviewerApproval() ||
					this.por()?.canHaveImplementerApproval() ||
					this.por()?.canHaveProxyApproval() ||
					this.por()?.canHaveOTCRMApproval() ||
					this.por()?.canHaveCyberSecApproval() ||
					this.por()?.canHaveSolutionArchitectApproval() ||
					this.por()?.canEscalateApproval() ||
					this.por()?.canHaveProxyArchApproval() ||
					(this.por()?.canEscalateToCyberSec() && !this.por()?.canContinueRequest())) && (
					<>
						<TreeNavigation.Item
							label={this.por().isInState(WorkflowState.AwaitingImplementation) ? 'Success' : 'Approve'}
							className="em-c-btn em-c-btn--secondary em-c-btn--small"
							onClick={() => {
								if (this.por().isInState(WorkflowState.AwaitingImplementation)) {
									this.openDecisionModal('complete', 'success');
								} else {
									this.openDecisionModal('approve');
								}
							}}
						/>
						<br />
						<br />
						<TreeNavigation.Item
							label={this.por().isInState(WorkflowState.AwaitingImplementation) ? 'Failure' : 'Reject'}
							className="em-c-btn em-c-btn--secondary em-c-btn--small"
							onClick={() => {
								if (this.por().isInState(WorkflowState.AwaitingImplementation)) {
									this.openDecisionModal('complete');
								} else {
									this.openDecisionModal('reject');
								}
							}}
						/>
						<br />
						<br />
						{this.por()?.canBeCancelled() && (
							<TreeNavigation.Item
								label={'Cancel'}
								className="em-c-btn em-c-btn--secondary em-c-btn--small"
								onClick={() => this.openDecisionModal('cancel')}
							/>
						)}
						<br />
						<br />
						{this.por()?.canEscalateApproval() && (
							<>
								{this.por()?.direction !== PortOpeningRequestsDirection.iBossProxyToInternet && (
									<>
										<TreeNavigation.Item
											label={'Escalate to Solution Architect'}
											className="em-c-btn em-c-btn--secondary em-c-btn--small"
											onClick={() => {
												this.openDecisionModal('escalate', 'SolutionArchitect');
											}}
										/>
										<br />
										<br />
										{this.por()?.type === OnPremPortOpeningRequestsTypes.InternalCertConnection && (
											<>
												<TreeNavigation.Item
													label={'Escalate to OTCRM'}
													className="em-c-btn em-c-btn--secondary em-c-btn--small"
													onClick={() => {
														this.openDecisionModal('escalate', 'OTCRM');
													}}
												/>
												<br />
												<br />
											</>
										)}
									</>
								)}
								{this.por()?.type === OnPremPortOpeningRequestsTypes.InternetDMZ &&
									this.por()?.direction === PortOpeningRequestsDirection.iBossProxyToInternet && (
										<>
											<TreeNavigation.Item
												label={'Escalate to Proxy Architect'}
												className="em-c-btn em-c-btn--secondary em-c-btn--small"
												onClick={() => {
													this.openDecisionModal('escalate', 'ProxyArchitect');
												}}
											/>
											<br />
											<br />
										</>
									)}
							</>
						)}
						{this.por()?.canEscalateToCyberSec() && (
							<>
								<TreeNavigation.Item
									label={'Escalate to CyberSec'}
									className="em-c-btn em-c-btn--secondary em-c-btn--small"
									onClick={() => {
										this.openDecisionModal('escalate', 'CyberSec');
									}}
								/>
								<br />
								<br />
							</>
						)}
						{this.por()?.canSendToReview() && (
							<>
								<TreeNavigation.Item
									label="Send to Review"
									className="em-c-btn em-c-btn--secondary em-c-btn--small"
									onClick={() => {
										this.openDecisionModal('review');
									}}
								/>
								<br />
								<br />
							</>
						)}
					</>
				)}
			</TreeNavigation>
		);

	editActions = (size: ButtonSize) => (
		<ButtonBar className="edit-button-bar">
			{!this.state.operationInProgress && (
				<>
					<ButtonBar.Item>
						<Button size={size} variant="secondary" onClick={this.cancelEdit}>
							<div className="action-button__icon">
								<Icon size={size} icon="x-filled" />
							</div>
							<span>Cancel</span>
						</Button>
					</ButtonBar.Item>
					<ButtonBar.Item separator />
				</>
			)}
			<ButtonBar.Item>
				<Button
					size={size}
					variant="primary"
					disabled={!this.formModel.isValid() || this.state.operationInProgress}
					onClick={() => this.handleSave()}
				>
					{this.state.operationInProgress ? (
						<>
							<Loader className="icon-loader em-c-icon--small" />
							<span>Loading...</span>
						</>
					) : (
						<>
							<div className="action-button__icon">
								<Icon size={size} icon="save-disk" />
							</div>
							<span>Finish Review</span>
						</>
					)}
				</Button>
			</ButtonBar.Item>
		</ButtonBar>
	);

	enableEdit = async () => {
		this.setState({
			editMode: true,
		});
	};

	cancelEdit = () => {
		this.setState({ editMode: false });
		this.resetStateForm();
	};

	openDecisionModal = (
		type: 'approve' | 'reject' | 'review' | 'cancel' | 'complete' | 'escalate',
		escalationType?: string
	) => {
		this.setState({
			decisionModalVisible: {
				[type]: true,
			},
			escalationType: escalationType || null,
		});
	};

	closeDecisionModal = () => {
		this.setState({
			decisionModalVisible: {},
			modalComment: '',
		});
	};

	handleEscalate = async () => {
		this.handleOperationConfirmed({
			operation: async () => {
				const model = {
					reviewReason: this.state.modalComment,
					OTCRMApproval: this.state.escalationType === 'OTCRM',
					proxyArchitectApproval: this.state.escalationType === 'ProxyArchitect',
				};
				await this.OnPremObjectRequestService.doEscalation(model, this.por()?.id);
			},
			inProgressMessage: 'Escalating...',
			successMessage: 'Request escalated successfully.',
		});
	};

	setEmbedAlertSuccess = (message) => {
		this.setState(
			{
				submissionAlert: {
					variant: 'success',
					text: message,
					visible: true,
				},
			},
			() => {
				setTimeout(this.handleSubmissionAlertClose, 5000);
			}
		);
	};

	decisionModalConfirmationField = () => ({
		label: 'Please, provide the reason.',
		value: this.state.modalComment,
		validation: {
			required: true,
		},
		onChange: (ev) => {
			this.setState({
				modalComment: ev.target.value,
			});
		},
	});

	handleApprove = async () => {
		this.handleOperationConfirmed({
			operation: async () => {
				let model: ChangeStatusObjectRequestOnPrem = {
					Successful: this.state.escalationType === 'success',
					Reason: this.state.modalComment,
				};
				await this.OnPremObjectRequestService.approve(model, this.por()?.id);
			},
			inProgressMessage: 'Approving...',
			successMessage: 'Request approved sucessfully.',
		});
	};

	handleReject = async () => {
		this.handleOperationConfirmed({
			operation: async () => {
				await this.OnPremObjectRequestService.reject(this.por()?.id, {
					rejectionReason: this.state.modalComment,
				});
			},
			inProgressMessage: 'Rejecting...',
			successMessage: 'Request rejected sucessfully.',
		});
	};

	handleComplete = async () => {
		await this.handleOperationConfirmed({
			operation: async () => {
				let model: ChangeStatusObjectRequestOnPrem = {
					Successful: this.state.escalationType === 'success',
					Reason: this.state.modalComment,
				};
				await this.OnPremObjectRequestService.doComplete(model, this.por()?.id);
			},
			inProgressMessage: 'Completing...',
			successMessage: 'Request completed successfully.',
		});
	};

	handleCancellation = async () => {
		this.handleOperationConfirmed({
			operation: async () => {
				let model: ChangeStatusObjectRequestOnPrem = {
					Successful: false,
					Reason: this.state.modalComment,
				};
				await this.OnPremObjectRequestService.cancel(this.por()?.id, model);
			},
			inProgressMessage: 'Cancelling...',
			successMessage: 'Request cancelled successfully.',
		});
	};

	handleReview = async () => {
		this.handleOperationConfirmed({
			operation: async () => {
				let model: ChangeStatusObjectRequestOnPrem = {
					Successful: false,
					Reason: this.state.modalComment,
				};
				await this.OnPremObjectRequestService.sendToReview(this.por()?.id, model);
			},
			inProgressMessage: 'Sending to review...',
			successMessage: 'Request sent to review successfully.',
		});
	};

	handleOperationConfirmed = async ({ operation, inProgressMessage, successMessage }) => {
		this.setSubmissionAlertInProgress(inProgressMessage);
		this.closeDecisionModal();
		try {
			await operation();
			await this.loadRequest(this.por()?.id);
			this.setEmbedAlertSuccess(successMessage);
		} catch (err) {
			const HTTP_INTERNAL_SERVER_ERROR_CODE = 500;
			if (err.status === HTTP_INTERNAL_SERVER_ERROR_CODE && err?.body?.message) {
				await this.loadRequest(this.por()?.id);
			}
			this.setSubmissionAlertError(
				err.response?.data.message ?? 'An error occured when processing your request. Please, try again later.'
			);
		} finally {
			this.setState({
				operationInProgress: false,
				modalComment: '',
			});
		}
	};

	render() {
		return !this.state.loading &&
			this.por() != null &&
			this.por()?.isEditable() &&
			this.por()?.isInState(WorkflowState.Draft) ? (
			<OnPremPortOpeningRequestsCreate draftRequest={this.por()} />
		) : (
			<>
				<WorkflowDetailWrapper
					title={`Object Request #${this.por()?.id}`}
					workflowInstance={this.por()?.onPremWorkflowInstance}
					loading={this.state.loading}
					linkTree={this.getLinkTree()}
					actions={this.state.editMode ? this.editActions('small') : this.actions()}
					fromPOR
				>
					{this.state.submissionAlert.visible && (
						<Alert variant={this.state.submissionAlert.variant} onClose={this.handleSubmissionAlertClose}>
							{this.state.submissionAlert.text}
						</Alert>
					)}
					<Grid variant="halves">
						<Grid.Item>
							<OnPremPORTypeInput
								type={{
									value: this.por()?.type?.name,
									disabled: true,
								}}
							/>
						</Grid.Item>
					</Grid>
					<Grid variant="2-up">
						<Grid.Item>
							<OnPremPORScopeInput
								direction={{
									value: this.por()?.direction?.name,
									disabled: true,
								}}
								type={this.state.stateForm.selectedType}
							/>
						</Grid.Item>
						<Grid.Item>
							<TextInputField
								label="Change Request Ticket"
								{...this.stateFormHandler().changeTicketId}
								disabled={true}
							/>
						</Grid.Item>
					</Grid>
					{this.requiresApproverVerification(this.por()?.type?.name) && (
						<Grid variant="2-up">
							<Grid.Item>
								<TextInputField
									label="Tracker Id"
									{...this.stateFormHandler().trackerID}
									disabled={this.state.operationInProgress || !this.state.editMode}
									//scope={this.state.stateForm?.selectedType}
									readOnly={this.state.loadingTracker}
									note={
										this.state.loadingTracker
											? "Validating..."
											: this.state.failedTracker
											? this.state.errorTracker
											: ""
									}
								/>
							</Grid.Item>
						</Grid>
					)}
					<Grid variant="halves">
						<Grid.Item>
							{this.requiresDOAGApproval(this.por()?.type?.name) && (
								<ApproverInput
									{...this.stateFormHandler().approverDOAG}
									disabled={this.state.operationInProgress || !this.state.editMode}
								/>
							)}
							{this.requiresApproverVerification(this.por()?.type?.name) && (
								<SelectField
									label="Approver"
									aria-placeholder={this.stateFormHandler().ownerDelegate.value}
									className="full-width"
									{...this.stateFormHandler().ownerDelegate}
									disabled={
										this.state.operationInProgress ||
										this.stateFormHandler().ownerDelegate.options.length == 0 ||
										this.state.loadingTracker ||
										!this.state.editMode
									}
									isLoading={this.stateFormHandler().ownerDelegate.options.length == 0}
								/>
							)}
						</Grid.Item>
						<Grid.Item>
							<UserLookup
								label="Technical contact"
								{...this.stateFormHandler().contact}
								disabled={this.state.operationInProgress || !this.state.editMode}
							/>
						</Grid.Item>
					</Grid>
					{this.requiresAppEndorserApproval(this.por()?.type?.name) && (
						<Grid variant="2-up">
							<Grid.Item>
								<CartaInput
									{...this.stateFormHandler().cartaId}
									oneOptionOnly={this.state.stateForm.cartaId.length > 0}
									disabled={this.state.operationInProgress || !this.state.editMode}
									hideNotes={this.state.operationInProgress || !this.state.editMode}
									hideTooltip={true}
								/>
							</Grid.Item>
							<Grid.Item>
								<SelectField
									label="Approver (Business Owner, IT Owner, IT Architect)"
									className="full-width"
									{...this.stateFormHandler().appEndorser}
									disabled={
										this.state.operationInProgress ||
										this.stateFormHandler().appEndorser.options.length == 0 ||
										!this.state.editMode ||
										this.stateFormHandler().cartaId.value.length == 0
									}
									isLoading={this.stateFormHandler().appEndorser.options.length === 0}
									note={
										(this.stateFormHandler().appEndorser.options.length == 0 ||
											this.stateFormHandler().cartaId.value.length == 0) &&
										'First select the DBM'
									}
								/>
							</Grid.Item>
						</Grid>
					)}
					{this.requiresApproverVerification(this.state.stateForm?.selectedType) && (
						<Grid variant="2-up">
							<Grid.Item>
								<ToggleField
									{...this.stateFormHandler().siteCoordination}
									id='siteCoordination'
									label="Site Coordination Required"
									options={[
										{ value: 'true', text: 'Yes' },
										{ value: 'false', text: 'No' },
									]}
									disabled={this.state.operationInProgress || !this.state.editMode}
								/>
							</Grid.Item>
						</Grid>
					)}
					<Grid>
						<Grid.Item>
							<ProgressBarBig
								workflowState={
									this.por()?.onPremWorkflowInstance.currentWorkflowInstanceState.onPremWorkflowState
								}
								por={this.por()}
								type={this.por()?.type?.name || ''}
								scope={this.por()?.direction.name || ''}
							/>
						</Grid.Item>
					</Grid>
					<br></br>
					<TextAreaField
						label="Business Justification"
						{...this.stateFormHandler().justification}
						disabled={this.state.operationInProgress || !this.state.editMode}
					/>
					<OnPremObjectTable
						{...this.stateFormHandler().ruleset}
						implementedObjects={this.state.implementedObjects}
						readonly={this.state.operationInProgress || !this.state.editMode}
						currentWorkflowState={
							this.por()?.onPremWorkflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value
						}
						fromDetails
						selectedFromExisting={this.state.selectedFromExisting}
						setSelectedFromExisting={this.setSelectedFromExisting}
					/>
					{this.state.editMode && this.editActions('medium')}
				</WorkflowDetailWrapper>
				<AlertModal {...this.state.endModal} willTimeout={false} onClose={this.endAndRedirect} />
				<ConfirmModal
					visible={this.state.decisionModalVisible.approve}
					title={`Approve POR #${this.por()?.id}`}
					question="Are you sure you want to approve this request?"
					confirmationField={this.decisionModalConfirmationField()}
					onConfirm={this.handleApprove}
					onCancel={this.closeDecisionModal}
				/>
				<ConfirmModal
					visible={this.state.decisionModalVisible.cancel}
					title={`Cancel POR #${this.por()?.id}`}
					question="Are you sure you want to cancel this request? This action cannot be undone."
					confirmationField={this.decisionModalConfirmationField()}
					confirmButton={{
						label: 'Cancel Request',
						props: {
							variant: 'primary',
							color: 'negative',
						},
					}}
					onConfirm={() => this.handleCancellation()}
					onCancel={this.closeDecisionModal}
				/>
				<ConfirmModal
					visible={this.state.decisionModalVisible.escalate}
					title={`Escalate POR #${this.por()?.id}`}
					question="Are you sure you want to escalate this request?"
					confirmationField={this.decisionModalConfirmationField()}
					onConfirm={() => this.handleEscalate()}
					onCancel={this.closeDecisionModal}
				/>
				<ConfirmModal
					visible={this.state.decisionModalVisible.reject}
					title={`Reject POR #${this.por()?.id}`}
					question="Are you sure you want to reject this request?"
					confirmationField={this.decisionModalConfirmationField()}
					onConfirm={() => this.handleReject()}
					onCancel={this.closeDecisionModal}
				/>
				<ConfirmModal
					visible={this.state.decisionModalVisible.review}
					title={`Confirm Revision for POR #${this.por()?.id}`}
					question="Are you sure you want to send this request to review?"
					confirmationField={this.decisionModalConfirmationField()}
					onConfirm={() => this.handleReview()}
					onCancel={this.closeDecisionModal}
				/>
				<ConfirmModal
					visible={this.state.decisionModalVisible.complete}
					title={`Complete POR #${this.por()?.id}`}
					question="Are you sure you want to mark this request as complete?"
					confirmationField={this.decisionModalConfirmationField()}
					onConfirm={this.handleComplete}
					onCancel={this.closeDecisionModal}
				/>
			</>
		);
	}
}

const OnPremPortOpeningRequestsDetail = () => {
	return <ObjectRequestDetailsWithParams params={useParams()} />;
};

export default OnPremPortOpeningRequestsDetail;
